interface PendingSearchHelper {
  hasPendingRequests(): boolean;
  on(event: string, listener: () => void): unknown;
  once(event: string, listener: () => void): unknown;
  removeListener(event: string, listener: () => void): unknown;
}

interface SearchOwner {
  mainHelper: PendingSearchHelper | null;
  dispose(): unknown;
}

const guarded = new WeakSet<SearchOwner>();

/** InstantSearch removes all helper listeners on disposal, but outstanding
 * transport promises can still reject. Consume only these retired helpers'
 * errors until their queue settles; live searches retain normal error handling. */
export function guardSearchDisposal(instance: SearchOwner): void {
  if (guarded.has(instance)) return;
  guarded.add(instance);
  const dispose = instance.dispose;
  instance.dispose = function () {
    const helper = instance.mainHelper;
    const result = dispose.call(instance);
    if (helper && helper !== instance.mainHelper && helper.hasPendingRequests()) {
      const retiredError = () => {};
      helper.on("error", retiredError);
      helper.once("searchQueueEmpty", () => helper.removeListener("error", retiredError));
    }
    return result;
  };
}
